import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '@lohi/environments/environment';
import { BehaviorSubject, combineLatest, Observable, Subject, timer } from 'rxjs';
import { throttleTime } from 'rxjs/operators';
import { WebBanner } from '../types';

@Injectable({
  providedIn: 'root',
})
export class BannerService {
  private webBanner$$ = new BehaviorSubject<WebBanner>(null);
  private webBannerThrottle$$ = new Subject();
  private webBannerShared$ = this.webBanner$$.asObservable();
  public get webBanner$(): Observable<WebBanner> {
    this.webBannerThrottle$$.next();
    return this.webBannerShared$;
  }

  constructor(private httpClient: HttpClient) {
    combineLatest([this.webBannerThrottle$$, timer(0, 10 * 60 * 1000)])
      .pipe(throttleTime(1000))
      .subscribe(() => {
        this.loadWebBanner();
      });
  }

  private async loadWebBanner() {
    const response = await this.httpClient.get<WebBanner>(`${environment.api}/v1/admin/web_banner`).toPromise();
    if (response.text) {
      this.webBanner$$.next(response);
    } else {
      this.webBanner$$.next(null);
    }
  }
}
